/* ---------------------------------------------------------------------------
   POLICY PAGE TITLE

   Shopify writes the policy heading itself -- "Terms of service", "Privacy
   policy" -- and the wording is not editable: shopPolicyUpdate takes the body
   and nothing else, and the markup does not come from a theme section. So the
   heading is title-cased here.

   CSS cannot do this. text-transform: capitalize would give "Terms Of
   Service", capitalising the preposition too.
   --------------------------------------------------------------------------- */
(function () {
  /* Words that stay lowercase inside a title, unless they lead it. */
  const SMALL = new Set(['of', 'and', 'or', 'the', 'a', 'an', 'for', 'to', 'in', 'on', 'at', 'by']);

  const titleCase = (text) =>
    text
      .trim()
      .split(/\s+/)
      .map((word, i) => {
        const lower = word.toLowerCase();
        if (i > 0 && SMALL.has(lower)) return lower;
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');

  /* A Home / <policy> breadcrumb, matching the content pages. These pages come
     from Shopify's own markup, so there is no Liquid of ours to render it in
     and it has to be built here. */
  function addBreadcrumb(container, label) {
    if (!container || container.querySelector('.syn-breadcrumb--page')) return;
    const nav = document.createElement('nav');
    nav.className = 'syn-breadcrumb syn-breadcrumb--page';
    nav.setAttribute('aria-label', 'Breadcrumb');

    const home = document.createElement('a');
    home.href = '/';
    home.textContent = 'Home';

    const sep = document.createElement('span');
    sep.className = 'syn-breadcrumb__sep';
    sep.setAttribute('aria-hidden', 'true');
    sep.textContent = '/';

    const here = document.createElement('span');
    here.className = 'syn-breadcrumb__current';
    here.setAttribute('aria-current', 'page');
    here.textContent = label;

    nav.append(home, sep, here);

    /* Before the policy container, not inside it. Shopify centres that
       container at its reading width, so a breadcrumb placed within it sits
       far in from the page edge while every other page has one at the
       container edge. The wrapper restores the site container. */
    const wrap = document.createElement('div');
    wrap.className = 'syn-breadcrumb__wrap';
    wrap.appendChild(nav);
    container.parentNode.insertBefore(wrap, container);
  }

  const heading = document.querySelector('.shopify-policy__title h1');
  if (!heading) return;

  const fixed = titleCase(heading.textContent);
  if (fixed !== heading.textContent) heading.textContent = fixed;

  addBreadcrumb(document.querySelector('.shopify-policy__container'), fixed);
})();
